"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__MismatchEndParenthesis = exports.__MismatchStartParenthesis = exports.__PEnd = exports.__PStart = exports.__PContent = exports.__Parentheses = exports.parenthesesTypeStrings = void 0;
const __1 = require("..");
exports.parenthesesTypeStrings = [
    "round",
    "square",
    "curly",
    "squareb",
];
class __Parentheses extends __1.EL {
    tag = "__Parentheses";
    get isControl() { return true; }
    attr;
    children;
    get content() {
        return this.children.find(c => c instanceof __PContent);
    }
    get start() {
        return this.children.find(c => c instanceof __PStart);
    }
    get end() {
        return this.children.find(c => c instanceof __PEnd);
    }
    constructor(options) {
        super("__Parentheses");
        const { type, depth, start, end, content, range } = options;
        this.attr = {
            type,
            depth: `${depth}`,
        };
        this.children = [
            new __PStart(type, start, range && range.start),
            new __PContent(type, content, range && range.content),
            new __PEnd(type, end, range && range.end),
        ];
        if (range) {
            this.range = [range.start[0], range.end[1]];
        }
    }
}
exports.__Parentheses = __Parentheses;
class __PContent extends __1.EL {
    tag = "__PContent";
    get isControl() { return true; }
    attr;
    children;
    constructor(type, content, range = null) {
        super("__PContent", {}, [], range);
        this.attr = { type };
        this.children = content;
    }
}
exports.__PContent = __PContent;
class __PStart extends __1.EL {
    tag = "__PStart";
    get isControl() { return true; }
    attr;
    children;
    constructor(type, text, range = null) {
        super("__PStart", {}, [], range);
        this.attr = { type };
        this.children = [text];
    }
}
exports.__PStart = __PStart;
class __PEnd extends __1.EL {
    tag = "__PEnd";
    get isControl() { return true; }
    attr;
    children;
    constructor(type, text, range = null) {
        super("__PEnd", {}, [], range);
        this.attr = { type };
        this.children = [text];
    }
}
exports.__PEnd = __PEnd;
class __MismatchStartParenthesis extends __1.EL {
    tag = "__MismatchStartParenthesis";
    get isControl() { return true; }
    // public override attr: {
    //     type: ParenthesesType,
    // };
    children;
    constructor(
    // type: ParenthesesType,
    text, range = null) {
        super("__MismatchStartParenthesis", {}, [], range);
        // this.attr = { type };
        this.children = [text];
    }
}
exports.__MismatchStartParenthesis = __MismatchStartParenthesis;
class __MismatchEndParenthesis extends __1.EL {
    tag = "__MismatchEndParenthesis";
    get isControl() { return true; }
    // public override attr: {
    //     type: ParenthesesType,
    // };
    children;
    constructor(
    // type: ParenthesesType,
    text, range = null) {
        super("__MismatchEndParenthesis", {}, [], range);
        // this.attr = { type };
        this.children = [text];
    }
}
exports.__MismatchEndParenthesis = __MismatchEndParenthesis;
//# sourceMappingURL=parentheses.js.map